import axios from "axios";
import { useEffect, useState } from "react";
import { apiCall_domainV2 } from "../api";
import { useParams } from "react-router-dom";
import Header from "../header";
import Spinner from "../Spinner/Spinner";
import Form from "react-bootstrap/Form";
import { Input } from "@mui/material";

const EvaluationDetail = () => {
  const [questions, setQuestions] = useState([]);
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const headers = {
      Authorization: localStorage.getItem("Api_key"),
      "content-type": "application/json",
    };
    setLoading(true);
    axios
      .get(`${apiCall_domainV2}/customer/evaluations/answer/list/${id}`, {
        headers: headers,
      })
      .then((res) => {
        setQuestions(res.data.data);
        setLoading(false);
      });
  }, []);
  return (
    <>
      <Header showSearchBar={true} title={"ارزیابی "} isDarkTheme={true} />
      {!loading ? (
        <div className="d-flex m-4 flex-column gap-4 ">
          {questions.map((q) => (
            <div className="row gap-2" key={q.id}>
              <label className="form-label fs-6 fw-bolder text-dark mb-4">
                {q.question}
              </label>

              {q.question_type === "multiple_choice" ? (
                <div
                  key={`inline-checkbox`}
                  className="mb-3 d-flex justify-content-start gap-4"
                >
                  {q.answers.map((o) => (
                    <Form.Check
                      checked
                      label={o}
                      name="group1"
                      type={"checkbox"}
                      id={`inline-checkbox-1`}
                    />
                  ))}
                </div>
              ) : q.question_type === "single_choice" ? (
                <div
                  key={`inline-radio`}
                  className="mb-3 d-flex justify-content-start gap-4"
                >
                  {q.answers.map((o) => (
                    <Form.Check
                      checked
                      label={o}
                      name="group1"
                      type={"radio"}
                      id={`inline-radio-1`}
                    />
                  ))}
                </div>
              ) : q.question_type === "text" ? (
                <Input
                  disabled
                  value={q.answers[0]}
                  className={"form-control form-control-lg form-control-solid"}
                  type="text"
                  autoComplete="off"
                />
              ) : (
                <Input
                  disabled
                  value={q.answers[0]}
                  className={"form-control form-control-lg form-control-solid"}
                  type="number"
                  autoComplete="off"
                />
              )}
              <label className="form-label fs-6 fw-bolder text-dark mb-4">
                توضیحات برای سوال ({q.question})
              </label>
              <textarea
                value={q.comment}
                className={"form-control form-control-lg form-control-solid"}
              />
            </div>
          ))}
        </div>
      ) : (
        <Spinner />
      )}
    </>
  );
};

export default EvaluationDetail;
